export default __webpack_public_path__ + "static/daniel-new@2x-f596eb1453fe35d344904c38f85aa86b.webp";